module.exports = __webpack_public_path__ + "img/scene2-10.d198396e.jpg";